import React from 'react'
import Dialog from '@mui/material/Dialog'

import { Loader, Icon } from '../../../../components/UI'
import JobPostModalHeader from './JobPostModalHeader'
import JobPostModalImages from './JobPostModalImages'
import JobPostModalInfo from './JobPostModalInfo'
import ErrorBoundary from '../../../../components/Shared/ErrorBoundary'

const JobPostModal = ({ isOpen, isLoading, job, onClose }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'relative xl:!max-w-[1194px] !p-[32px] !rounded-[10px] !bg-[#FEEBDD] !shadow-modal',
      }}
    >
      {!isLoading || job ? (
        <div className="w-full flex flex-col items-start">
          <div className="w-full flex items-center justify-between">
            <button className="flex items-center" onClick={onClose}>
              <Icon name="arrow-left-line" color="#F67443" className="w-[24px] h-[24px]" />

              <span className="text-primary-100 font-medium text-sm ml-[12px]">Back</span>
            </button>

            <div>
              <Icon name="flag" color="#F79009" className="w-[24px] h-[24px]" />
            </div>
          </div>

          <div className="w-full flex gap-[10px] mt-[10px]">
            <div className="w-[56.7%] flex flex-col items-start">
              <JobPostModalHeader job={job} />

              <ErrorBoundary>
                <JobPostModalImages job={job} />
              </ErrorBoundary>
            </div>

            <JobPostModalInfo job={job} />
          </div>
        </div>
      ) : (
        isLoading && (
          <div className="w-full h-[642px] text-primary-100 flex items-center justify-center">
            <Loader />
          </div>
        )
      )}
    </Dialog>
  )
}

export default JobPostModal
